import {Box, Subtitle2, styled, Paragraph1, Button, DeleteOutlineIcon, ContainedButton} from '../../../ui-library';

export const ContainerBox = styled(Box)`
    border-radius: 10px;
    width: 720px;
    min-height: 500px;
    max-height: 750px;
    padding: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
    background-color: #F3F4F6;
`;

export const ContainerBtnBox = styled(Box)`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 26px;
`;

export const Space = styled(Box)`
    margin-top: 30px;
`;

export const P = styled(Paragraph1)`
    margin-top: 14px;
`;

export const ReferenceTitle = styled(Subtitle2)`
    ${({ theme }) => theme.typography.subtitle2};
    margin-top: 30px;
    `;

export const AddClassBtn = styled(ContainedButton)`
    font-size: 16px;
    line-height: 26px;
    margin-top: 10px;
`;

export const InputContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    width: 100%;
    gap: 14px;
`;

export const DeleteClassBtn = styled(Button)`
    ${({ theme }) => theme.typography.button};
    display: flex;
    align-content: center;
    background: transparent;
    font-size: 14px;
    line-height: 24px;
    height: 36px;
    cursor: pointer;
    padding-left:16px;
    padding-right:16px;
    width: 240px;
    color: ${({ theme }) => theme.palette.grey['600']};
    border: 1px solid ${({ theme }) => theme.palette.grey['600']};
    :hover{
        color: ${({ theme }) => theme.palette.grey['600']};
        background: transparent;
        border: 1px solid ${({ theme }) => theme.palette.grey['600']};
    }
`;

export const DeleteClassIcon = styled(DeleteOutlineIcon)`
    color: ${({ theme }) => theme.palette.grey['600']};
    width: 20px;
    height: 20px;
`;

export const ContainerBoxRandom = styled(Box)`
    border-radius: 10px;
    width: 720px;
    padding: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
    background-color: #F3F4F6;
`;
